<div class="auto-assignee-container">
  <div class="auto-assignee-header">
    <div class="auto-assignee-summary">
      <span class="text-green-600 font-semibold">{{ activeCount }} Active</span>
      <span class="text-gray-400">·</span>
      <span class="text-yellow-600 font-semibold">{{ pausedCount }} Paused</span>
    </div>
  </div>

  @if (me) {
    <div class="me-panel">
      <div class="flex items-center justify-between gap-2">
        <div class="flex flex-col min-w-0">
          <span class="text-xs text-gray-500 uppercase tracking-wide">You</span>
          <span class="text-black acc-name font-semibold truncate">{{ me.name }}</span>
          @if (!me._autoAssignee.active && me._autoAssignee.lastReasonPause) {
            <small class="text-xs text-gray-600 truncate" style="text-wrap: auto;" [title]="me._autoAssignee.lastReasonPause">
              {{ me._autoAssignee.lastReasonPause }}
            </small>
          }
          @if (!me._autoAssignee.active && me._autoAssignee.statusChangeAt) {
            <small class="text-xs text-gray-500">
              Since {{ me._autoAssignee.statusChangeAt | date:'MM/dd/yy hh:mm a' }}
            </small>
          }
        </div>
        <div class="flex items-center gap-1 flex-shrink-0">
          <button
            type="button"
            class="status-pill cursor-pointer"
            [class.receiving]="me._autoAssignee.active"
            [class.paused]="!me._autoAssignee.active"
            (click)="toggleSelfActive()"
            [title]="me._autoAssignee.active ? 'Click to pause' : 'Click to activate'"
          >
            {{ me._autoAssignee.active ? 'Active' : 'Paused' }}
          </button>
        </div>
      </div>

      @if ((me._autoAssignee.active && me._autoAssignee.statusChangeStartDate) || me._autoAssignee.statusChangeEndDate) {
        <div class="mt-2 flex items-center justify-between gap-2 flex-wrap">
          <span class="schedule-pill">
            @if (me._autoAssignee.active && me._autoAssignee.statusChangeStartDate) {
              <span><b>Turn Off:</b> {{ me._autoAssignee.statusChangeStartDate | date:'MM/dd/yy hh:mm a' }}</span>
            }
            @if (me._autoAssignee.statusChangeEndDate) {
              <span><b>Turn On:</b> {{ me._autoAssignee.statusChangeEndDate | date:'MM/dd/yy hh:mm a' }}</span>
            }
          </span>
          <button type="button" class="link-btn" (click)="clearSchedule()">Clear</button>
        </div>
      }

      @if (!scheduleOpen) {
        <button type="button" class="schedule-btn mt-2" (click)="openSchedule()">
          <i class="far fa-clock"></i>
          {{ (me._autoAssignee.statusChangeStartDate || me._autoAssignee.statusChangeEndDate) ? 'Edit Schedule' : 'Schedule Status Change' }}
        </button>
      } @else {
        <div class="schedule-form mt-2">
          @if (me._autoAssignee.active) {
            <div class="schedule-form__field">
              <span class="schedule-form__label">Turn Off:</span>
              <app-date
                idInfo="self-schedule-start"
                [isContainerStyle]="true"
                [label]="'Date'"
                [options]="{ placeholder: 'Select start date' }"
                [parent]="tempSchedule"
                [time]="true"
                startKey="statusChangeStartDate"
                (onSave)="tempSchedule.statusChangeStartDate = $event"
              ></app-date>
            </div>
            <div class="schedule-form__field">
              <span class="schedule-form__label">Turn On:</span>
              <app-date
                idInfo="self-schedule-end"
                [isContainerStyle]="true"
                [options]="{ placeholder: 'Select end date' }"
                [label]="'Date'"
                [parent]="tempSchedule"
                [time]="true"
                startKey="statusChangeEndDate"
                (onSave)="tempSchedule.statusChangeEndDate = $event"
              ></app-date>
            </div>
          } @else {
            <div class="schedule-form__field">
              <span class="schedule-form__label">Turn On:</span>
              <app-date
                idInfo="self-schedule-end"
                [isContainerStyle]="true"
                [options]="{ placeholder: 'Select enable date' }"
                [parent]="tempSchedule"
                [time]="true"
                startKey="statusChangeEndDate"
                (onSave)="tempSchedule.statusChangeEndDate = $event"
              ></app-date>
            </div>
          }
          <div class="flex gap-2 mt-2">
            <button type="button" class="primary-btn" (click)="saveSchedule()">Save</button>
            <button type="button" class="secondary-btn" (click)="closeSchedule()">Cancel</button>
          </div>
        </div>
      }
    </div>
  }

  @if (!loaded && !users.length) {
    <div class="auto-assignee-empty">Loading...</div>
  } @else if (!users.length) {
    <div class="auto-assignee-empty">No auto-assignees configured for this company.</div>
  }

  @for (user of users; track user._id) {
    @if (!isMe(user)) {
      <div class="user-container">
        <div class="flex items-center justify-between w-full gap-2 min-w-0">
          <div class="flex flex-col flex-1 min-w-0">
            <span class="text-black text-md acc-name font-semibold truncate">{{ user.name }}</span>
            @if (!user._autoAssignee.active && user._autoAssignee.lastReasonPause) {
              <small class="text-xs text-gray-600 truncate" style="text-wrap: auto;" [title]="user._autoAssignee.lastReasonPause">
                {{ user._autoAssignee.lastReasonPause }}
              </small>
            }
            @if (!user._autoAssignee.active && user._autoAssignee.statusChangeAt) {
              <small class="text-xs text-gray-500">
                Since {{ user._autoAssignee.statusChangeAt | date:'MM/dd/yy hh:mm a' }}
              </small>
            }
            @if ((user._autoAssignee.active && user._autoAssignee.statusChangeStartDate) || user._autoAssignee.statusChangeEndDate) {
              <span class="schedule-pill">
                @if (user._autoAssignee.active && user._autoAssignee.statusChangeStartDate) {
                  <span><b>Turn Off:</b> {{ user._autoAssignee.statusChangeStartDate | date:'MM/dd/yy hh:mm a' }}</span>
                }
                @if (user._autoAssignee.statusChangeEndDate) {
                  <span><b>Turn On:</b> {{ user._autoAssignee.statusChangeEndDate | date:'MM/dd/yy hh:mm a' }}</span>
                }
              </span>
            }
          </div>
          <div class="flex items-center gap-1 flex-shrink-0">
            @if (user._autoAssignee.active) {
              <span class="status-pill receiving">Active</span>
            } @else {
              <span class="status-pill paused">Paused</span>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
